import { mode } from "@chakra-ui/theme-tools";

/** @type {import("@chakra-ui/react").ComponentStyleConfig} */
export const TEXT_THEME = {
  baseStyle(props) {
    const { colorScheme } = props;
    return {
      color: colorScheme
        ? mode(`${colorScheme}.600`, `${colorScheme}.300`)(props)
        : mode("brandPrimary.700", "whiteAlpha.900")(props),
    };
  },
  defaultProps: {
    variant: "text-default",
  },
  variants: {
    h0: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "4rem",
      fontWeight: 300,
      lineHeight: "5rem",
    },
    h1: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "2.5rem",
      fontWeight: 300,
      lineHeight: "normal",
      color: "brandPrimary.900",
    },
    h2: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "2rem",
      fontWeight: 300,
      lineHeight: "normal",
    },
    h3: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "1.5rem",
      fontWeight: 300,
      lineHeight: "normal",
    },
    h4: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "1.375rem",
      fontWeight: 300,
      lineHeight: "normal",
    },
    h5: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "1.25rem",
      fontWeight: 300,
      lineHeight: "normal",
    },
    h6: {
      fontFamily: "'Cocon', sans-serif",
      fontSize: "1.125rem",
      fontWeight: 300,
      lineHeight: "normal",
    },
    header: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "1.375rem",
    },
    "text-default": {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "1.3125rem",
    },
    "text-moyen": {
      fontSize: "1.125rem",
      fontWeight: 500,
      lineHeight: "1.75rem",
      letterSpacing: "-0.0112rem",
    },
    "text-large": {
      fontSize: "1.25rem",
      fontWeight: 400,
      lineHeight: "1.75rem",
    },
    "text-14": {
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: "1.3125rem",
    },
    "text-small": {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: "normal",
    },
    "menu-dropdown": {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "1.375rem",
      letterSpacing: "-0.01rem",
    },
    button: {
      fontSize: "1.25rem",
      fontWeight: 400,
      lineHeight: "normal",
    },
    "button-small": {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "normal",
    },
  },
};
